var i=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;function r(x){return x.match(i)}export{r as a};
